<div class="color-bar"></div>

<div>    
    <app-bi-cspuio-lista
        [filtros]="filtros"
        (exibir)="selecionar($event)">    
    </app-bi-cspuio-lista>
</div>
